import React from 'react';

function Footer() {
    return (
        <footer className="bg-black py-8">
            <div className="container mx-auto px-6 text-center text-gray-400">
                <p>&copy; 2025 R.A.W. Fitness. All Rights Reserved.</p>
                <p className="text-sm">Rise and Win</p>
            </div>
        </footer>
    );
}

export default Footer;
